import { render, staticRenderFns } from "./shopauthority.vue?vue&type=template&id=7066b297&scoped=true&"
import script from "./shopauthority.vue?vue&type=script&lang=js&"
export * from "./shopauthority.vue?vue&type=script&lang=js&"
import style0 from "./shopauthority.vue?vue&type=style&index=0&id=7066b297&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7066b297",
  null
  
)

export default component.exports